module.exports = __webpack_public_path__ + "static/media/notes.ae35238c.svg";